// extracted by mini-css-extract-plugin
export default {"publicationsDiv":"Publications_publicationsDiv__8lj9M"};